import React from 'react';

const AGB = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-20 px-4" data-testid="agb-page">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8 md:p-12">
        <h1 className="text-4xl font-bold mb-2 text-gray-900">Allgemeine Geschäftsbedingungen (AGB)</h1>
        <p className="text-xl font-semibold text-gray-800 mb-2">UMULM EVENTS</p>
        <p className="text-gray-600 mb-8 italic">
          (für Eventplanung, Vermittlung, Catering, Foodtrucks, Dienstleisterkoordination und Eventservice)
        </p>

        <div className="space-y-8 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">1. Geltungsbereich</h2>
            <p>
              (1) Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge, Angebote,
              Lieferungen und sonstigen Leistungen zwischen UMULM EVENTS (nachfolgend „Anbieter")
              und seinen Kunden (nachfolgend „Kunde").
            </p>
            <p className="mt-2">(2) Die AGB gelten insbesondere für folgende Leistungen:</p>
            <ul className="list-none ml-4 mt-2 space-y-1">
              <li>a) Vermittlung von Foodtrucks, Catering-Partnern und Eventdienstleistern</li>
              <li>b) Planung, Organisation und Durchführung von Veranstaltungen</li>
              <li>c) Koordination von Aufbau, Ablauf und Abbau</li>
              <li>d) Vermietung und Vermittlung von Eventequipment</li>
              <li>e) Vermittlung von Personal, Künstlern, DJs, Fotografen, Technik etc.</li>
            </ul>
            <p className="mt-2">
              (3) Abweichende Bedingungen des Kunden gelten nur bei ausdrücklicher schriftlicher
              Zustimmung des Anbieters.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">2. Vertragspartner</h2>
            <p>Vertragspartner ist:</p>
            <p className="mt-2 font-semibold">Claudiu Hartwig</p>
            <p>Eisenhowerstraße 1</p>
            <p>89231 Neu-Ulm</p>
            <p className="mt-3 font-semibold">UMULM EVENTS</p>
            <p>www.umulmevents.de</p>
            <p>E-Mail: info@umulmevents.de</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">3. Vertragsschluss</h2>
            <p>(1) Angebote des Anbieters sind freibleibend und unverbindlich.</p>
            <p className="mt-2">(2) Ein Vertrag kommt zustande durch:</p>
            <ul className="list-none ml-4 mt-2 space-y-1">
              <li>a) schriftliche Angebotsannahme durch den Kunden</li>
              <li>b) schriftliche Auftragsbestätigung durch den Anbieter</li>
              <li>c) Durchführung der vereinbarten Leistung</li>
            </ul>
            <p className="mt-2">
              (3) Änderungen und Ergänzungen bedürfen der Textform (z.B. E-Mail oder WhatsApp).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">4. Leistungsumfang</h2>
            <p>(1) Der konkrete Leistungsumfang ergibt sich aus dem jeweiligen Angebot.</p>
            <p className="mt-2">(2) Leistungen können unter anderem umfassen:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Eventplanung und Beratung</li>
              <li>Vermittlung von Foodtrucks, Bars, Catering und Dienstleistern</li>
              <li>Kommunikation mit Partnerfirmen</li>
              <li>Ablaufplanung</li>
              <li>Platzierung von Foodtrucks und Dienstleistern</li>
              <li>Aufbaukoordination</li>
              <li>Betreuung während der Veranstaltung</li>
              <li>Abbauorganisation</li>
            </ul>
            <p className="mt-2">
              (3) Der Anbieter ist berechtigt, geeignete Subunternehmer oder Partnerfirmen
              einzusetzen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">5. Preise & Zahlungsbedingungen</h2>
            <p>
              (1) Alle Preise verstehen sich netto zzgl. gesetzlicher Umsatzsteuer, sofern nicht
              anders angegeben.
            </p>
            <p className="mt-2">(2) Rechnungen sind innerhalb von 14 Tagen ohne Abzug zahlbar.</p>
            <p className="mt-2">(3) Der Anbieter ist berechtigt, Anzahlungen zu verlangen.</p>
            <p className="mt-2">(4) Bei Zahlungsverzug gelten die gesetzlichen Verzugsregelungen.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">6. Mitwirkungspflichten des Kunden</h2>
            <p>Der Kunde verpflichtet sich:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>alle relevanten Informationen rechtzeitig bereitzustellen</li>
              <li>Veranstaltungsort, Zufahrt und Stellflächen sicherzustellen</li>
              <li>notwendige Genehmigungen einzuholen</li>
              <li>Strom, Wasser oder Infrastruktur bereitzustellen, sofern vereinbart</li>
              <li>Änderungen rechtzeitig mitzuteilen</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">7. Änderungen & Zusatzleistungen</h2>
            <p>(1) Änderungen nach Angebotsbestätigung können gesondert berechnet werden.</p>
            <p className="mt-2">(2) Kurzfristige Zusatzwünsche werden nach Aufwand abgerechnet.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">8. Stornierung durch den Kunden</h2>
            <p>Bei Stornierung fallen folgende Gebühren an:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>ab Buchung: 25 %</li>
              <li>ab 30 Tage vor Event: 50 %</li>
              <li>ab 14 Tage vor Event: 75 %</li>
              <li>ab 7 Tage vor Event: 90 %</li>
              <li>am Veranstaltungstag: 100 %</li>
            </ul>
            <p className="mt-2">Berechnungsgrundlage ist der bestätigte Auftragswert.</p>
            <p className="mt-2">Bereits gebuchte Fremdleistungen werden vollständig berechnet.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">9. Rücktritt durch den Anbieter</h2>
            <p>Der Anbieter kann vom Vertrag zurücktreten, wenn:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Zahlungen trotz Mahnung ausbleiben</li>
              <li>wichtige Mitwirkungspflichten verletzt werden</li>
              <li>höhere Gewalt vorliegt</li>
              <li>Durchführung unzumutbar oder unmöglich wird</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">10. Vermittlungsleistungen</h2>
            <p>
              (1) Bei reiner Vermittlung kommt der Vertrag direkt zwischen Kunde und dem jeweiligen
              Dienstleister zustande.
            </p>
            <p className="mt-2">
              (2) Der Anbieter haftet in diesem Fall nur für die ordnungsgemäße Vermittlung, nicht
              für die Durchführung.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">11. Haftung</h2>
            <p>(1) Der Anbieter haftet uneingeschränkt bei Vorsatz und grober Fahrlässigkeit.</p>
            <p className="mt-2">(2) Bei leichter Fahrlässigkeit nur bei Verletzung wesentlicher Vertragspflichten.</p>
            <p className="mt-2">(3) Für Leistungen externer Partner haftet der jeweilige Dienstleister selbst.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">12. Höhere Gewalt</h2>
            <p>
              Bei höherer Gewalt (z.B. Unwetter, Streik, Pandemie, behördliche Verbote, Stromausfall)
              entfällt die Leistungspflicht für die Dauer der Störung.
            </p>
            <p className="mt-2">Bereits entstandene Kosten sind vom Kunden zu tragen.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">13. Foto- und Videoaufnahmen</h2>
            <p>
              (1) Der Anbieter ist berechtigt, Foto- und Videoaufnahmen von Veranstaltungen zu
              Marketingzwecken zu erstellen und zu veröffentlichen.
            </p>
            <p className="mt-2">(2) Personenbezogene Daten werden dabei nicht genannt.</p>
            <p className="mt-2">(3) Der Kunde informiert Gäste eigenverantwortlich über mögliche Aufnahmen.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">14. Datenschutz</h2>
            <p>
              Personenbezogene Daten werden ausschließlich zur Vertragsabwicklung verarbeitet.
            </p>
            <p className="mt-2">
              Weitere Informationen befinden sich in der{' '}
              <a href="/datenschutz" className="text-red-600 hover:underline">
                Datenschutzerklärung
              </a>{' '}
              auf: www.umulmevents.de/datenschutz
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3 text-gray-900">15. Gerichtsstand / Schlussbestimmungen</h2>
            <p>(1) Es gilt deutsches Recht.</p>
            <p className="mt-2">(2) Gerichtsstand ist – soweit zulässig – der Sitz des Anbieters.</p>
            <p className="mt-2">
              (3) Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen
              Regelungen unberührt.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 text-sm text-gray-500">
          <p>Stand: {new Date().toLocaleDateString('de-DE')}</p>
          <p className="mt-2">
            UMULM EVENTS – Claudiu Hartwig, Eisenhowerstraße 1, 89231 Neu-Ulm
          </p>
        </div>
      </div>
    </div>
  );
};

export default AGB;
